import { useCallback, useState } from "react";

const SIDEBAR_OPEN_KEY = "sidebarOpen";

const readStoredOpen = () => localStorage.getItem(SIDEBAR_OPEN_KEY) === "true";

const useSidebarOpen = () => {
  const [open, setOpenState] = useState(readStoredOpen);

  const setOpen = useCallback(value => {
    setOpenState(prev => {
      const next = typeof value === "function" ? value(prev) : value;
      localStorage.setItem(SIDEBAR_OPEN_KEY, String(Boolean(next)));
      return next;
    });
  }, []);

  return [open, setOpen];
};

export default useSidebarOpen;
